import * as React from 'react';
import { useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import CurrentCreditBalanceInitializationModal from 'components/backorder/modal/CurrentCreditBalanceInitializationModal';
import AddCreditModal from 'components/backorder/modal/AddCreditModal';
import styled from '@emotion/styled';
import { toMantissaWithThousandComma } from 'modules/utils/number';

interface Props {
  groupId: string;
  currentCreditBalance: number;
}

const CurrentCreditBalance = ({ groupId, currentCreditBalance }: Props) => {
  const [initializeCreditModalVisibility, setInitializeCreditModalVisibility] =
    useState<boolean>(false);
  const [addCreditModalVisibility, setAddCreditModalVisibility] = useState(false);
  const isInitializeButtonDisabled = currentCreditBalance === 0;

  return (
    <>
      <RowContainer>
        <Typography variant={'body2'} color={currentCreditBalance < 0 ? 'error' : 'textPrimary'}>
          {toMantissaWithThousandComma(currentCreditBalance)}
        </Typography>
        <ButtonsWrapper>
          <Button
            variant={'contained'}
            size={'small'}
            color={'primary'}
            onClick={() => setInitializeCreditModalVisibility(true)}
            disabled={isInitializeButtonDisabled}
          >
            Initialize to 0.00
          </Button>
          <Button
            variant={'contained'}
            size={'small'}
            color={'primary'}
            onClick={() => setAddCreditModalVisibility(true)}
          >
            Add Credits
          </Button>
        </ButtonsWrapper>
      </RowContainer>
      {initializeCreditModalVisibility && (
        <CurrentCreditBalanceInitializationModal
          groupId={groupId}
          onClose={() => setInitializeCreditModalVisibility(false)}
        />
      )}

      {addCreditModalVisibility && (
        <AddCreditModal
          groupId={groupId}
          currentCredit={currentCreditBalance}
          onClose={() => setAddCreditModalVisibility(false)}
        />
      )}
    </>
  );
};

export default CurrentCreditBalance;

const RowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
